import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Member, User } from '@stigg-types/apiTypes';
import { useAuth0 } from '@auth0/auth0-react';
import { useSupportChatContext } from './SupportChatContext';
import { RootState } from '../../redux/store';
import { useCurrentMember } from '../../modules/auth/hooks/useCurrentMember';
import config from '../../env.config';

const boot = (user: User, member?: Member) => {
  window.pylon = {
    chat_settings: {
      app_id: config.pylonId,
      email: user.email || '',
      name: user.name || '',
      userId: user.id || '',
      email_hash: user.supportChatToken || '',
      avatar_url: user.profileImageUrl || '',
      ...(member
        ? {
            account_id: member.account.id || '',
            account_name: member.account.displayName,
          }
        : {}),
    },
  };
};

export function SupportChatButton() {
  const { isVisible } = useSupportChatContext();
  const { user: auth0User } = useAuth0();
  const user: User | null = useSelector((state: RootState) => state.authReducer.user);
  const member = useCurrentMember();

  useEffect(() => {
    if (user && auth0User?.email_verified && isVisible) {
      boot(user, member);
      window.Pylon('showChatBubble');
    } else if (!isVisible) {
      window.Pylon('hideChatBubble');
    }
  }, [user, member, auth0User, isVisible]);

  return null;
}
